import React from 'react';
import Button from '../../../../components/Button/Button';
import './Phase2.css';

export const SaveStatus = ({ isSaved, hasMismatch, roundName }) => {
  if (isSaved && !hasMismatch) {
    return (
      <div className="save-status">
        <p>✅ <strong>{roundName} gæt gemt!</strong></p>
      </div>
    );
  }
  return <></>;
};

const SaveGuessSection = ({
  isSaved,
  hasMismatch,
  areAllGuessed,
  guessedCount,
  totalMatches,
  onSave,
  isLocked,
  roundName,
  roundNamePlural
}) => {
  if (isSaved && !hasMismatch) {
    return <></>;
  }

  return (
    <div className="save-guess-section">
      {hasMismatch && (
        <p style={{ color: 'orange', fontWeight: 'bold' }}>
          ⚠️ Nogle kampe er ændret - du skal opdatere dit gæt!
        </p>
      )}
      {areAllGuessed ? (
        <p><strong>Alle {totalMatches} {roundNamePlural} kampe er gættet på!</strong></p>
      ) : (
        <p>{guessedCount} ud af {totalMatches} {roundNamePlural} kampe gættet - gæt på {totalMatches - guessedCount} mere for at gemme</p>
      )}
      <Button 
        onClick={onSave}
        title={hasMismatch ? `Opdater ${roundName} Gæt` : `Gem ${roundName} Gæt`}
        variant="contained"
        color="confirmation"
        disabled={!areAllGuessed || isLocked}
      />
    </div>
  );
};

export default SaveGuessSection;

